import {texture} from "p3";
import common from "../common";
import definitions from "../definitions";
import { locale } from "../utils";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";

export default class PauseScene extends MenuScene {
    constructor() {
        super("pause");

        this._homeButton = null;
        this._closeButton = null;
        this._muteButton = null;
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        if (!common.saveData.settings.musicMute) {
            P3.audio.playMusic("music_pause_loop");
        }

        this.interactive = true;

        this.createFill();
        this.createTitleBanner(locale('ui_paused'));
        this.createPauseHelpPanel();

        this._homeButton = P3.Button.create(
            texture("btn_small_out"),
            null,
            null,
            texture("btn_icon_home")
        );
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this._homeButton.overSoundName = "sfx_btn_generic_rollover";
        this._homeButton.clickSoundName = "sfx_btn_generic_press_00";
        this.addChild(this._homeButton);

        this._closeButton = P3.Button.create(
            texture("btn_small_out"),
            null,
            null,
            texture("btn_icon_cross")
        );
        this._closeButton.signals.click.add(this.onCloseButtonClick, this);
        this._closeButton.overSoundName = "sfx_btn_generic_rollover";
        this._closeButton.clickSoundName = "sfx_btn_generic_press_00";
        this.addChild(this._closeButton);

        let states = new P3.ButtonStates(texture("btn_small_out"));
        states.icon = texture("btn_icon_sound_on");
        states.iconAlt = texture("btn_icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.overSoundName = "sfx_btn_generic_rollover";
        this._muteButton.clickSoundName = "sfx_btn_generic_press_00";
        this.signalListeners.push(this._muteButton.signals.click.add(() => {
            common.saveData.settings.muted = !this._muteButton.isEnabled();
            common.saveData.saveGame();

            // tracking
            let interaction = !common.saveData.settings.muted ? "sound on" : "sound off";
            common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
                section: common.tracking.getSection(),
                contenttitle: interaction,
                interaction: interaction,
                progress: common.tracking.progress,
                interactionevent: 1
            });
        }, this));
        this.addChild(this._muteButton);

        this.helpPanel.signals.resume.add(this.onCloseButtonClick, this);

        this.resize();
    }

    destroy() {
        this._homeButton.destroy();
        this._closeButton.destroy();
        this._muteButton.destroy();

        P3.audio.stopMusic();

        super.destroy();
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            this._homeButton.position.set(
                (common.STAGE_WIDTH - P3.View.width + this._homeButton.width) * 0.5 + this.buttonMargin.x,
                this._homeButton.height * 0.5 + this.buttonMargin.y
            );

            this._closeButton.position.set(
                (common.STAGE_WIDTH + P3.View.width - this._closeButton.width) * 0.5 - this.buttonMargin.width,
                this._closeButton.height * 0.5 + this.buttonMargin.y
            );

            this._muteButton.position.set(
                (common.STAGE_WIDTH + P3.View.width - this._muteButton.width) * 0.5 - this.buttonMargin.width - this.buttonSpacing,
                this._muteButton.height * 0.5 + this.buttonMargin.y
            );
        }
    }

    onHomeButtonClick() {
        this.signals.previous.dispatch();

        // tracking
        const interaction = "back to main menu";
        common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
            section: common.tracking.getSection(),
            contenttitle: interaction,
            interaction: interaction,
            progress: common.tracking.progress,
            interactionevent: 1
        });
    }

    onCloseButtonClick() {
        this.signals.next.dispatch();

        // tracking
        const interaction = "pause menu closed";
        common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
            section: common.tracking.getSection(),
            contenttitle: interaction,
            interaction: interaction,
            progress: common.tracking.progress,
            interactionevent: 1
        });
    }
}

/**
 * @static
 * @type {MapScene}
 */
PauseScene.active = null;